import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from '../static/styles/Thankyou.module.css';

const BundleThankyou = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        document.title = 'Thank You | Jazz ESL';
        if (!location.state) {
            navigate('/bundle-vouchers', { replace: true });
        }
    }, []);

    const phone = location.state?.phone || '';
    const playerId = location.state?.playerId || location.state?.freefireId || '';
    const reward = location.state?.reward || '70 Free Fire Diamonds';
    const playerIdLabel = location.state?.playerIdLabel || 'Free Fire ID';
    const processingLine = location.state?.processingLine || 'Your Free Fire Diamonds are being processed.';

    if (!location.state) {
        return null;
    }

    return (
        <div className={styles.container}>

            {/* SUCCESS ICON */}
            <div className={styles.successWrap}>
                <div className={styles.checkCircle}></div>
            </div>

            <div className={`${styles.statusBadge} ${styles.fadeUp} ${styles.delay1}`}>
                ● CLAIM CONFIRMED
            </div>

            {/* TEXT */}
            <h2 className={`${styles.mainTitle} ${styles.fadeUp} ${styles.delay2}`}>THANK YOU!</h2>

            <p className={`${styles.subText} ${styles.fadeUp} ${styles.delay3}`}>
                {processingLine}<br />
                We will deliver them to your in-game account.
            </p>

            {/* RECEIPT CARD */}
            <div className={`${styles.receiptCard} ${styles.fadeUp} ${styles.delay4}`}>
                <div className={styles.receiptHeader}>
                    <span>CLAIM RECEIPT</span>
                    <strong>#ESL</strong>
                </div>

                <div className={styles.row}>
                    <span>Phone</span>
                    <span>{phone || 'nill'}</span>
                </div>

                <div className={styles.row}>
                    <span>{playerIdLabel}</span>
                    <span>{playerId || 'nill'}</span>
                </div>

                <div className={styles.row}>
                    <span>Reward</span>
                    <span>{reward}</span>
                </div>

                <div className={styles.row}>
                    <span>ETA</span>
                    <span>24–48 hours</span>
                </div>
            </div>

            {/* BUTTON */}
            <button
                className={`${styles.primaryBtn} ${styles.fadeUp} ${styles.delay5}`}
                onClick={() => navigate('/')}
            >
                EXPLORE ESL →
            </button>

        </div>
    );
};

export default BundleThankyou;
